import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PaperboyWordmark from '../components/PaperboyWordmark';
import './AuthPages.css';
import './GoogleCallbackPage.css';

const GoogleCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithTokens } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const errorParam = searchParams.get('error');
    if (errorParam) {
      setError(errorParam);
      return;
    }

    const accessToken = searchParams.get('access_token');
    const refreshToken = searchParams.get('refresh_token');

    if (accessToken && refreshToken) {
      loginWithTokens(accessToken, refreshToken)
        .then(() => {
          navigate('/feed', { replace: true });
        })
        .catch((err) => {
          setError(err.message || 'Failed to complete sign-in');
        });
    } else {
      setError('Missing authentication tokens');
    }
  }, [searchParams, loginWithTokens, navigate]);

  if (error) {
    return (
      <div className="oauth-callback">
        <div className="oauth-callback__inner">
          <PaperboyWordmark size={28} />
          <span className="mono-tag mono-tag--accent oauth-callback__eyebrow">
            <span className="oauth-callback__dot" aria-hidden="true" />
            Sign-in failed · Google
          </span>
          <p className="oauth-callback__copy">{error}</p>
          <Link to="/login" className="btn-ink">Back to Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="oauth-callback" role="status" aria-live="polite">
      <div className="oauth-callback__inner">
        <PaperboyWordmark size={28} />
        <span className="mono-tag mono-tag--accent oauth-callback__eyebrow">
          <span className="oauth-callback__dot oauth-callback__dot--blink" aria-hidden="true" />
          Authenticating · Google
        </span>
        <p className="oauth-callback__copy">
          Hold tight &mdash; we&rsquo;re getting your front page ready.
        </p>
      </div>
    </div>
  );
};

export default GoogleCallbackPage;
